<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: BCC Pubs
      Author: SweetAs
    Author URL: http://sweetas.xyz
========================================================================================== -->
<template>        
  <div class="mt-3">
    <div class="vx-row mb-6">
      <div class="vx-col w-full">  
        <vx-card>
          <div class="mt-3">  

            <vs-table
              stripe 
              pagination
              :max-items="pagPageSize"   
              :data="vdata"
              search
              @selected="getVolunteer">
                <template slot="header">
                   <vs-button color="success" type="filled" icon-pack="feather" 
                   icon="icon-plus" @click="NewUser" style="float:right;" >New</vs-button>
                </template>
              <template slot="thead">
              <vs-th sort-key="firstname">Firstname</vs-th>
              <vs-th sort-key="lastname">Lastname</vs-th>
              <vs-th sort-key="lastname">Email</vs-th>
              <vs-th sort-key="ifpoints">Infopoint Sites</vs-th>
              </template>
              <template slot-scope="{data}">
              <vs-tr  :data="tr" :key="i" v-for="(tr, i) in data">
                  <vs-td :data="data[i].firstname">
                  {{ data[i].firstname }}
                  </vs-td>
                  <vs-td :data="data[i].lastname">
                  {{ data[i].lastname }}
                  </vs-td>
                  <vs-td :data="data[i].email">
                  {{ data[i].email }}
                  </vs-td>
                  <vs-td :data="data[i].ifpoints">
                    <vs-chip
                      color="primary"
                      :key="i"
                      v-for="(chip,i) in data[i].ifpoints.split(',')" >
                      {{ chip }}
                    </vs-chip> 
                  </vs-td>
              </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>  
    <vs-popup
      fullscreen 
      title="Volunteer"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt ">
        <vs-alert :active.sync="changesDetected"  color="danger" class="text-center">
           <span>Warning: Details have changed, please save Details before exiting.</span>
        </vs-alert>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/2">
            <vx-card title="Contact">
              <div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <small class="small-title">Title</small>
                      <v-select :options="['Mr', 'Mrs', 'Ms','Dr','Sir', 'Lady']" v-model="sw_title" taggable push-tags size="large">                            
                    </v-select>
                  </div>
                </div>
                  <div class="vx-row mb-2">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Firstname" v-model="sw_firstname" />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Surname" v-model="sw_surname" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Email" v-model="sw_email" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Telephone" v-model="sw_telephone" />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Mobile" v-model="sw_mobile" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-1/4">
                    <ul>
                      <li>
                        
                          <label for="sw_pw_reset">Force PW Reset</label>
                        <vx-tooltip text="Force user to reset password on next login" position="left" >
                        <vs-switch v-model="sw_pw_reset"/>
                        </vx-tooltip>
                      </li>
                    </ul>                  
                  </div>
                  <div class="vx-col w-1/4">
                    <ul>
                      <li>
                          <label for="sw_acc_active">Account Active</label>
                    
                        <vs-switch v-model="sw_acc_active"/>
                      </li>
                    </ul>
                  </div>
                  <div class="vx-col w-1/2">
                    <label for="">Account</label>
                    <ul>
                      <li>
                        <vs-radio v-model="sw_company" vs-name="sw_company" vs-value="Infopoint">Volunteer</vs-radio>
                        <vs-radio v-model="sw_company" vs-name="sw_company" vs-value="Dawleys" class="ml-5">Dawleys</vs-radio> 
                      </li>
                    </ul>  
                    <span class="text-danger mt-2"> Dawleys inherits ALL infopoint sites</span>           
                  </div>
                </div>
              </div>
            </vx-card>
            <vx-card title="Infopoint Sites" class="mt-5">
              <div>
                <div class="vx-row mb-2">                 
                  <div class="vx-col w-full">
                   <div class="total">
                      <vs-chips color="rgb(145, 32, 159)" placeholder="Enter IP Site" v-model="ipsites">
                        <vs-chip
                          :key="chip"
                          @click="removeIpSite(chip)"
                          v-for="chip in ipsites" closable>
                          {{ chip }}
                        </vs-chip>   
                      </vs-chips> 
                    </div> 
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-1/2">
            <vx-card title="Delivery Address">
              <div>
                <v-select :filterable="false" :options="sw_options" label="Id" :clearable="true"
                 @search="onSearch" v-model="sw_select" :components="{Deselect}">
                  <template slot="no-options">
                   {{ search_text }}
                  </template>
                  <template slot="option" slot-scope="option" :label="option.Id">
                    <div class="d-center">
                      {{ option.Text }} <small> {{ option.Description }} </small>
                      </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.text }}
                    </div>
                  </template>
                </v-select>
                <div class="vx-row mt-2 mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 1" v-model="sw_address1" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 2" v-model="sw_address2" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Address Line 3"  v-model="sw_address3" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" label-placeholder="Town" v-model="sw_town" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Country" v-model="sw_country" />
                  </div>
                  <div class="vx-col w-1/2">
                    <vs-input class="w-full" label-placeholder="Postcode" v-model="sw_postcode" />
                  </div>
                </div>
              </div>
            </vx-card>
            <div class="vx-row" vs-align="center"  vs-type="flex" vs-justify="space-around" vs-w="12">
              <div class="vx-col w-1/2 mt-5">
                <!-- <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" @click="clearAddressAndDetect" >Undo</vs-button> -->
              </div>
              <div class="vx-col w-1/2 mt-5">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-trash-2" @click="updateAdd" style="float:right;" >{{isUpdateOrNew}}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'
export default{
  components: { 
     'v-select': vSelect,
  },
  data () {
    return { 
      sw_isNew: false,
      sw_pw_reset:false,
      sw_acc_active:false,      
      changesDetected:false,
      ipsiteList:[],
      key:'MR34-BM33-RH83-EA34',   
      activePrompt:false, 
      vdata:[],   
      pagPages:0,
      pagPageSize: 8,
      pagCurrentX: 1,
      sw_address1:'',
      sw_address2:'',
      sw_address3:'',
      sw_town:'',
      sw_country:'',
      sw_postcode:'',
      sw_addresses:[],
      sw_options:[],
      sw_select:[],
      sw_id: '',    
      sw_title: '',
      sw_firstname: '',
      sw_surname: '',
      sw_email: '',
      sw_telephone: '',
      sw_mobile: '',
      sw_password: '',
      sw_company: '',
      sw_tr:'',
      search_container: '',
      search_text: 'Search for Address..',
      Deselect: {
        render: createElement => {
          return createElement('span', {
            on: {
              click: ()=>{
                this.$emit('deselect',this)
              }
            }
          },'❌')
        }
      },
    }
  },
      watch: {
     'sw_select' (payload) {
          if(!payload){
          return
        }
        if (payload.Type == 'Postcode') {      
          this.search_container = payload.Id
          this.onSearch('')

        }
       if (payload.Type == 'Address') { 
         var vm = this
         const cl = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws?Key=${vm.key}&Country=GBR&Id=${encodeURIComponent(payload.Id)}`
        fetch(cl).then(res => {        
          res.json().then(j => {
            const n = j.Items[0]
            vm.sw_address1 =`${n.BuildingName} ${n.BuildingNumber}`
            vm.sw_address2 = n.Street
            vm.sw_address3 = ''
            vm.sw_town = n.City  
            vm.sw_postcode = n.PostalCode  
            vm.sw_country = n.CountryName
            vm.DetectChanges()
          })
        })    
      }  
     } 
  },
  computed: {
     st_sites: {
      get () { 
        return this.$store.state.dataList.sites 
      }
    },
    isUpdateOrNew(){
      return  this.sw_isNew ? 'Add' : 'Update'
    },
    validName(){
      return true
    },
    ipsites: {
      get () {  
       var  arr =  this.ipsiteList.filter(function (item) {
            return item.toUpperCase().indexOf("IP") === 0 || item.toUpperCase().indexOf("DAWLEYS") === 0
        })
       return [...new Set(arr)]     
      },
      set (val) {
        val = val.map(function(x){ return x.toUpperCase() })
        this.ipsiteList =  val
      }
    },
  },
  mounted () {},
  methods: {
    NewUser(){
      this.sw_id = ''
      this.sw_title = ''
      this.sw_firstname = ''
      this.sw_surname = ''
      this.sw_email = ''
      this.sw_telephone = ''
      this.sw_mobile = ''
      this.sw_address1 = ''
      this.sw_address2 = ''
      this.sw_address3 = ''
      this.sw_town  = ''
      this.sw_postcode = ''
      this.sw_country = '' 
      this.hasAddress = false
      this.activePrompt = true       
      this.hasAddress = false
      this.sw_isNew = true
      this.sw_acc_active = false
      this.sw_pw_reset= true
      this.ipsiteList = []
      this.company = '',
      this.sw_password = ''
      this.changesDetected= false
      this.sw_company = "Infopoint"

    },
    DetectChanges(){
      const y= this
      const w= y.sw_tr
      delete w["vregion"]
      delete w["vcountrySC"]
      delete w["ifpoints"]
      delete w["forcereset"]
      delete w["valid"]
      var u= {
         title: y.sw_title,
        firstname: y.sw_firstname,
        lastname: y.sw_surname,
        email: y.sw_email,
        telephone: y.sw_telephone,
        mobile: y.sw_mobile,
        vaddress1: y.sw_address1,
        vaddress2: y.sw_address2,
        vaddress3: y.sw_address3,
        vtown: y.sw_town,
        vcountry: y.sw_country,
        vpostcode: y.sw_postcode,
      }   
      this.changesDetected =  JSON.stringify(u) !== JSON.stringify(w) 
    },
    removeIpSite (item) {
      const ty = this.ipsites      
      ty.splice(ty.indexOf(item), 1)      
      this.ipsites = ty
    },
    onClear(){
      this.clearAddressAndDetect()
      this.sw_options =[]
      this.search_container
      this.sw_select =[]
      this.DetectChanges()

    },
    onSearch (search) {
      var vm = this
      const sc = vm.search_container
      search = sc === '' ? search : sc
      const cl = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws?Key=${this.key}&Country=GBR&Text=${encodeURIComponent(search)}&IsMiddleware=false&Container=${sc}&Origin=&Language=en-gb`
      fetch(cl).then(res => {        
        res.json().then(json => {
          vm.sw_options = json.Items
        })
      })      
    },
    clearAddress () {
      this.sw_address1 = ''
      this.sw_address2 = ''
      this.sw_address3 = ''
      this.sw_town  = ''
      this.sw_postcode = ''
      this.sw_country = '' 
      this.hasAddress = false
     // this.DetectChanges()
    },
    clearAddressAndDetect () {
      this.clearAddress()
      this.DetectChanges()
    },    
    getVolunteers () {
      const _self = this
      _self.$vs.loading()     
      _self.$store.dispatch('dataList/getVolunteers').then(r => {        
         _self.vdata = JSON.parse(r.data.data) || []
         _self.$vs.loading.close()
      })
    },
    getVolunteer(tr){
      this.sw_id = tr.guid
      this.sw_isNew = false     
      this.activePrompt = true 
      this.sw_email = tr.email
      this.sw_firstname = tr.firstname
      this.sw_surname = tr.lastname
      this.sw_mobile = tr.mobile
      this.sw_telephone = tr.telephone
      this.sw_title = tr.title
      this.sw_address1 = tr.vaddress1
      this.sw_address2 = tr.vaddress2
      this.sw_address3 = tr.vaddress3
      this.sw_country = tr.vcountry
      this.sw_postcode =tr.vpostcode     
      this.sw_town  = tr.vtown
      this.sw_pw_reset = tr.forcereset=='1',
      this.sw_acc_active = tr.valid =='1',  
      this.hasAddress = true
      this.ipsiteList = tr.ifpoints.split(',')
      this.sw_tr = tr   
      this.sw_company = tr.access,
      this.sw_password = ''

    },
    updateAdd(){
      const payload ={
        Id: this.sw_id,
        Title:  this.sw_title,
        FirstName:  this.sw_firstname,
        LastName: this.sw_surname,
        Email: this.sw_email,
        Mobile: this.sw_mobile,
        Telephone: this.sw_telephone,
        Address1: this.sw_address1,
        Address2: this.sw_address2,
        Address3: this.sw_address3,
        Town: this.sw_town,
        Country: this.sw_country,
        PostCode: this.sw_postcode,
        ForcePw: this.sw_pw_reset ? '1':'0',
        Active: this.sw_acc_active ? '1':'0',
        IpSiteList:  this.ipsiteList.toString(),
        Company:  this.company,
        Password: this.sw_email,
      }

       const _self = this
      _self.$vs.loading()
      _self.$store.dispatch('dataList/updateVolunteer', payload).then(q => {
        var t =  JSON.parse(q.data.data).Status>0
        var _upn = this.sw_id !='' ? 'User Added': 'User Updated'
        var _upnl = this.sw_id !='' ? 'added': 'updated'
        var _upi  = t ? 'success': 'error'
        var _upnn = t ? '': 'Not'       
        
        _self.activePrompt = false

        _self.$swal({
          title:  _upn,
          text: `${_self.sw_firstname} ${_self.sw_surname} has ${_upnn} been ${_upnl}`,
          icon: _upi,
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close'
        }).then(()=>{ 
          _self.getVolunteers()  
        })
        _self.$vs.loading.close()
      })
    }
  },
  created () {  
    this.getVolunteers()
    this.$on('deselect',this.onClear)
  }
}
</script>
<style lang="scss">
.round-border .vs-inputx{
  border: 0px!important; 
}
.vs-input--input:focus{
  border: 1px solid rgba(0, 0, 0, 0.1)!important;
  height: 38px !important;
  width: 101%;
  border-radius: 20px !important;
}

.round-border .input-span-placeholder{
  border-radius:40px!important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.round-border .vs-icon{
  padding-top: 4px;
}

.content-tr-expand{    justify-content: flex-end!important;}
.tr-expand td .tr-expand--close {background-color:inherit!important;}
.vs-con-table .empty {
     display: none!important;
}
.vs-dialog{
  max-width:none!important;
}
</style>

